import { computed } from '@angular/core';
import {
  signalStoreFeature,
  type,
  withComputed,
  withMethods,
} from '@ngrx/signals';
import { WorkspaceState } from './workspace.state';
import {
  Workspace,
  WorkspaceType,
  WorkspaceTypeKey,
} from '../../models/workspace';

export const workspaceTypes: WorkspaceType[] = [
  {
    value: 'indicatorCategory',
    label: 'Indikatorenordner',
    icon: 'fas fa-folder',
  },
  { value: 'dataLayerType', label: 'Räume', icon: 'fa-regular fa-map' },
  {
    value: 'poiDataLayerType',
    label: 'Standorte',
    icon: 'fas fa-location-dot',
  },
  {
    value: 'bookmarkCategory',
    label: 'Themenbereiche',
    icon: 'fas fa-layer-group',
  },
  { value: 'topic', label: 'Themen', icon: 'fas fa-book-open' },
];

export function withWorkspaceSelectors() {
  return signalStoreFeature(
    {
      state: type<WorkspaceState>(),
    },
    withMethods(store => ({
      //filterByType(type: WorkspaceTypeKey) {
      //  return Object.values(store.items()).filter(item => {
      //    return item.type === type;
      //  }) as Workspace[];
      //},
      //countByType(type: WorkspaceTypeKey) {
      //  return Object.values(store.items()).filter(item => {
      //    return item.type === type;
      //  }).length as number;
      //},
      mergeTypeGroups(workspaceIds: string[]): Record<string, string[]> {
        const workspaces = workspaceIds
          .map(id => store.items()[id])
          .filter(item => !!item);
        const mergedResult: Record<string, string[]> = {};

        workspaces.forEach(workspace => {
          const typeGroups = workspace.typeGroups;
          if (!typeGroups) return;
          Object.keys(typeGroups).forEach(id => {
            if (mergedResult[id]) {
              // Merge arrays and remove duplicates using Set
              mergedResult[id] = Array.from(
                new Set([...mergedResult[id], ...typeGroups[id]])
              );
            } else {
              // First occurrence of this id, copy the array
              mergedResult[id] = [...typeGroups[id]];
            }
          });
        });
        return mergedResult;
      },
    })),
    withComputed(({ items }) => ({
      count: computed(() => Object.keys(items()).length),
      asArray: computed(() => Object.values(items())),
      fallbackWorkspaces: computed(() => {
        return;
      }),
      //asGroupedByType: computed(() => {
      //  return Object.values(items()).reduce(
      //    (acc: { [key: string]: Workspace[] }, item: Workspace) => {
      //      acc[item.type] = acc[item.type] || [];
      //      acc[item.type].push(item);
      //      return acc;
      //    },
      //    {}
      //  );
      //}),
    }))
  );
}
